var _path, _path2, _rect, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 74,
    viewBox: "0 0 73 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 63.8369C60.5 65.7699 58.933 67.3369 57 67.3369H16C14.067 67.3369 12.5 65.7699 12.5 63.8369V7.98926C12.5 6.05626 14.067 4.48926 16 4.48926H44.0527C44.9795 4.48926 45.8685 4.85684 46.5246 5.51139L59.4719 18.4274C60.1301 19.084 60.5 19.9755 60.5 20.9052V63.8369Z",
    fill: "#C8EBFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 28.0571H47.375V31.0499H21.875V28.0571ZM21.875 34.0426H41.375V37.0354H21.875V34.0426ZM21.875 40.0281H47.375V43.0209H21.875V40.0281ZM21.875 46.0136H41.375V49.0064H21.875V46.0136Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.5,
    y: 51.1738,
    width: 22.5,
    height: 22.826,
    rx: 11.25,
    fill: "#3787FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.75 59.5244V65.6494",
    stroke: "white",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6875 62.5869H59.8125",
    stroke: "white",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.281346ca5994f4fad4fc292d478b8d08.svg";
export { ForwardRef as ReactComponent };